@if (isLoaded()) {
    <div
        id="edit-trading-symbol-view"
        class="edit-trading-symbol-view d-flex flex-column align-items-start justify-content-start p-3"
    >
        <mat-form-field class="w-100">
            <mat-label>Symbol</mat-label>
            <input type="text" matInput [(ngModel)]="tradingSymbolSymbol" [disabled]="!isNew" />
        </mat-form-field>
        <button
            mat-raised-button
            color="accent"
            class="mb-3"
            (click)="loadSymbolInfo()"
            [disabled]="tradingSymbol().symbol === ''"
        >
            <mat-icon>replay</mat-icon>
            Load symbol info
        </button>
        <mat-form-field class="w-100">
            <mat-label>Company name</mat-label>
            <input type="text" matInput [(ngModel)]="tradingSymbolCompanyName" />
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Icon</mat-label>
            <input type="text" matInput [(ngModel)]="tradingSymbolIcon" />
            <div class="symbol-icon" matIconPrefix>
                @if (tradingSymbolIcon()) {
                    <img [src]="tradingSymbolIcon()" alt="icon" />
                }
                @if (!tradingSymbolIcon()) {
                    <span class="logo mx-1 material-symbols-outlined">finance_mode</span>
                }
            </div>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Type</mat-label>
            <mat-select [(value)]="tradingSymbolType">
                @for (type of tradingSymbolTypes; track type) {
                    <mat-option [value]="type">{{ TradingSymbolType[type] }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Sector</mat-label>
            <mat-select [(value)]="tradingSymbolTradingGroupId">
                @for (group of groups; track group.id) {
                    <mat-option [value]="group.id">{{ group.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Exchange</mat-label>
            <mat-select [(value)]="tradingSymbolExchangeId">
                @for (exchange of exchanges; track exchange.id) {
                    <mat-option [value]="exchange.id">{{ exchange.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-checkbox [checked]="tradingSymbolIsActive" (change)="tradingSymbolIsActive.set($event.checked)"
            >Is Active</mat-checkbox
        >
        <mat-form-field class="w-100">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="tradingSymbolDescription"></textarea>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Comment</mat-label>
            <textarea matInput [(ngModel)]="tradingSymbolComment"></textarea>
        </mat-form-field>
        <div class="d-flex flex-row align-items-start justify-content-start gap-3">
            @if (isNew()) {
                <button mat-raised-button color="primary" (click)="create()" [disabled]="!isValid()">
                    <mat-icon>add</mat-icon>
                    Create
                </button>
            }
            @if (!isNew()) {
                <button mat-raised-button color="primary" (click)="update()" [disabled]="!isValid()">
                    <mat-icon>save</mat-icon>
                    Save
                </button>
            }
            <button mat-raised-button (click)="cancel()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
        </div>
    </div>
}
